// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';
import partsCoverageSearchStatusChangeModal from '../state/parts-coverage-search-status-change-modal';

const updatePartsCoverageSearchStatusChangeModal = (state, action) => partsCoverageSearchStatusChangeModal.update(state, {
    isVisible: {$set: action.isVisible}
});

export default (state = getDefaultState().partsCoverageSearchStatusChangeModal, action) => {

    const actionTypes = {
        [actions.UPDATE_PART_COVERAGE_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY]: updatePartsCoverageSearchStatusChangeModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/parts-coverage-search-status-change-modal.js